<template>
  <PublicIndexPage v-if="is_public === true">
  </PublicIndexPage>
  <index-page v-else>
  </index-page>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

import IndexPage from './components/IndexPage.vue'
import PublicIndexPage from '@/components/Public/PublicIndexPage.vue'

export default {
  name: 'app',
  components: {
    IndexPage, PublicIndexPage
  },
  data: function() {
    return {
      is_public: false
    }
  },
  created: function(){
    if (window.location.pathname.indexOf('public') !== -1){
      this.is_public = true
    }
    console.log('app vue' , window.location.pathname)
    console.log(this.is_public)
  },
  mounted: function() {
    this.initClarity(
      window, document, "clarity", "script", "ez5b9dcfot"
    )
  },
  errorCaptured(err, vm, info) {
    console.log(err)
    let error_param = {
      type: 'info',
      title: '系統訊息',
      icon: 'info',
      error_code: this.$bus.createErrorCode(vm.$options.name),
      error_message: this.$bus.pageCodeMapper[vm.$options.name].name + '頁面發生問題' + '，登入帳號: ' + vm.$bus.session.name || '',
      content: err.toString() 
    }

    this.$alert(error_param)

  },
  methods: {
    initClarity: function(c,l,a,r,i,t,y) {
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
